"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const lodash_1 = require("lodash");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const react_router_dom_1 = require("react-router-dom");
const constants_1 = require("@/constants");
const auth_1 = require("@/helpers/auth");
const services_1 = require("@/helpers/services");
const selectors_1 = __importDefault(require("@/selectors"));
const PrivateRoute = (props) => {
    const { component, user, path, exact, location, pending, groups } = props;
    const token = auth_1.getAuth();
    if (user || token) {
        if (user === null || user === void 0 ? void 0 : user.group) {
            if (groups && !lodash_1.includes(groups, user.group)) {
                // role not authorised so redirect to home page
                return react_1.default.createElement(react_router_dom_1.Redirect, { to: { pathname: constants_1.Routes.Home } });
            }
        }
        return react_1.default.createElement(react_router_dom_1.Route, { exact: exact, path: path, component: component });
    }
    if (pending || token) {
        // Fallback to suspense will user is loading
        throw Promise.reject();
    }
    return (react_1.default.createElement(react_router_dom_1.Redirect, { to: {
            pathname: constants_1.Routes.Login,
            search: location.search,
            state: { toRoute: location.pathname },
        } }));
};
PrivateRoute.defaultProps = {
    exact: false,
};
const mapStateToProps = (state) => ({
    user: selectors_1.default.user.getUser(state),
    pending: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.me),
});
const PrivateRouteWithRouter = react_router_1.withRouter(react_redux_1.connect(mapStateToProps)(PrivateRoute));
const WithSuspense = (props) => (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(react_1.default.Fragment, null) },
    react_1.default.createElement(PrivateRouteWithRouter, Object.assign({}, props))));
WithSuspense.defaultProps = {
    exact: false,
};
exports.default = WithSuspense;
